/* global $ */

// only including this because of FWP plugin hooks
/* eslint no-undef: 0  */
/* eslint no-unused-vars: 0  */

import { viewportWidth } from '../helpers/dom-tools';

const defaultHTML = $('#active_company .company-details').html();
const $companyDetails = $('#active_company .company-details');
const hiddenLabelHTML = $('.hiddenLabelHTML').html();
let firstPageLoad = true;
let $companyButton = null;
let isExpanded = null;
let hasLoaded = false;
let timeOutId = null;

// adds 'is-active' class to active facets
function markActiveFacets() {
	$.each(FWP.facets, function (name, vals) {
		if (FWP.facets[name].length > 0) {
			$('.facetwp-facet-' + name).addClass('is-active');
		} else {
			$('.facetwp-facet-' + name).removeClass('is-active');
		}
	});
}

// removes active state of all company listings
function clearSelected() {
	$('.company-listings .js-accordion-button').attr('aria-selected', false);
	$('.company-listings .js-accordion-button').attr('aria-expanded', false);
	$('.accordion__content').attr('aria-hidden', true);
	$('.accordion__content').removeClass('js-accordion-fully-open');
}

// expands active company accordion panel (mostly for mobile view)
function expandSelected() {
	isExpanded = $companyButton.attr('aria-expanded') === 'true';
	const $header = $companyButton.closest('.accordion__headline');
	const $section = $header.next('.accordion__content');
	$companyButton.attr('aria-expanded', !isExpanded);
	$section.attr('aria-hidden', isExpanded);
	$section.addClass('js-accordion-fully-open');

	if (!isExpanded) {
		clearTimeout(timeOutId);
		timeOutId = setTimeout(() => {
			$section.addClass('js-accordion-fully-open');
		}, 500);
	} else {
		$section.removeClass('js-accordion-fully-open');
		clearTimeout(timeOutId);
	}
}

// replaces active company div with selected listing details
function updateCompanyDetails() {
	$companyDetails.html($(window.location.hash).clone());
}

// smooth scrolls to selected company (for page load)
function scrollToCompany() {
	const scrollTime = 400;
	const $top = $.$body.find('#masthead');
	const navHeight = $top.innerHeight();

	if (viewportWidth() >= 992) {
		// scroll to active company card on desktop
		const $target = $('#active_company');
		if ($target.length) {
			const scrollTop = $target.offset().top - navHeight;
			// Animate
			$('.main-header').addClass('is-sticky'); // add this early so styles fade in faster
			$('html, body').animate({ scrollTop }, scrollTime);
		}
	} else {
		// scroll to active company accordion section on tablet + mobile
		//$companyButton.attr('data-slug')
		const companyName = window.location.hash.replace(/^#/, '');
		const $targetCompany = $('.companies').find(`
			[data-slug='${companyName}']
			`);
		if ($targetCompany.length) {
			const scrollTop = $targetCompany.offset().top - navHeight;
			// Animate
			$('.main-header').addClass('is-sticky'); // add this early so styles fade in faster
			$('html, body').animate({ scrollTop }, scrollTime);
		}
	}
}

// smooth scrolls to top of index (for page load w/ parameters and pagination clicks)
function scrollToIndex() {
	const scrollTime = 400;
	const $top = $.$body.find('#masthead');
	const navHeight = $top.innerHeight();
	const $target = $('.facets');
	const scrollTop = $target.offset().top - navHeight - 32;
	console.log('scrolltop is: ' + scrollTop);
	// Animate
	$('.main-header').addClass('is-sticky'); // add this early so styles fade in faster
	$('html, body').animate({ scrollTop }, scrollTime);
}

// makes sure labels are correct for all facets
function adjustFacetLabels() {
	// adds screen reader text for all facets
	$('.facetwp-facet').each(function () {
		const facetName = $(this).attr('data-name');
		const facetLabel = FWP.settings.labels[facetName];
		if ($('.facet-label-fixed[data-for="' + facetName + '"]').length < 1) {
			$(this).prepend(
				'<span class="screen-reader-text" data-for="' +
					facetName +
					'">' +
					facetLabel +
					' </span>'
			);
		}
	});

	// adjusts dropdown labels
	$('.facetwp-type-fselect').each(function () {
		const facetName = $(this).attr('data-name');
		const facetLabel = FWP.settings.labels[facetName];
		const fsLabel = $(this).find('.fs-label');
		const fsArrow = $(this).find('.fs-arrow');
		if ($('.facet-label-fixed[data-for="' + facetName + '"]').length < 1) {
			$(fsLabel).prepend(
				'<span class="facet-label-fixed small-paragraph" data-for="' +
					facetName +
					'">' +
					facetLabel +
					' </span>'
			);
			$(fsArrow).html(
				'<svg width="17" height="11" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0)"><path d="M17 2.878L14.348.5 8.5 5.744 2.652.5 0 2.878 8.5 10.5 17 2.878z" fill="#000"/></g><defs><clipPath id="clip0"><path fill="#fff" transform="rotate(90 8.25 8.75)" d="M0 0h10v17H0z"/></clipPath></defs></svg>'
			);
		}
	});

	// adjusts Outlier Companies label and note
	$('.facetwp-facet-only_show_outlier_companies').each(function () {
		const fsLabel = $(this).find('.facetwp-checkbox[data-value="1"]');
		$(fsLabel).html(hiddenLabelHTML);
	});
}

// handles page load/refresh finished for FacetWP parameters and selected company hash value if present
document.addEventListener('facetwp-loaded', () => {
	hasLoaded = true;
	//console.log('facetwp-loaded');

	// url has a hash parameter, so updates page accordingly
	if (window.location.hash) {
		// removes active state of all company listings
		clearSelected();

		// stores selected company value
		$companyButton = $(window.location.hash.replace('#', '.'));

		// expands selected company accordion panel (mostly for mobile view)
		expandSelected();

		// updates selected company placeholder div
		updateCompanyDetails();

		// smooth scrolls to selected company on page load
		scrollToCompany();
	}
	// no hash parameter
	else {
		// no company is selected, so sets active company to default helper text
		$('#active_company .company-details').html(defaultHTML);

		// resets the button variable to null
		$companyButton = null;

		// if no company selected, check for other parameters and scroll to index if they exist
		if (window.location.search) {
			if (firstPageLoad) {
				// only scroll on first load if not the search results page
				const $isSearchPage = $('body.search-results');
				if (!$isSearchPage.length) {
					scrollToIndex();
				}
			} else {
				// only scroll to index when using pagination, excludes other facet parameters
				const urlParams = new URLSearchParams(window.location.search);
				if (urlParams.has('_paged')) {
					scrollToIndex();
				}
			}
		}
	}

	// makes sure labels are added to dropdown selects
	adjustFacetLabels();

	// adds 'is-active' to active facets
	markActiveFacets();

	firstPageLoad = false;
});

// handles FacetWP refresh
document.addEventListener('facetwp-refresh', () => {
	if (hasLoaded) {
		adjustFacetLabels();
	}
});

// Companies Index Mobile Accordion
$.$body.on('click', '.company-listings .js-accordion-button', (e) => {
	e.preventDefault();
	// essentially scrolls to selected company card, but want to keep facets in view still to navigate
	// if (viewportWidth() >= 992) {
	// 	scrollToIndex();
	// }

	// removes active state of all other company listings
	// clearSelected();

	if (
		$companyButton &&
		$(e.currentTarget).attr('data-slug') ===
			$companyButton.attr('data-slug')
	) {
		// if already open, toggles selected company from active to inactive (mostly for mobile accordion view)
		$companyButton = null;
	} else {
		// stores selected company value
		$companyButton = $(e.currentTarget);

		// adds selected company hash to url without triggering FacetWP refresh
		const hash = '#' + $companyButton.attr('data-slug');
		const url = window.location.href;
		const urlHash = window.location.hash;
		const indexOfHash = url.indexOf(urlHash) || url.length;
		const hashlessUrl = url.substr(0, indexOfHash);
		if (history.pushState) {
			const newurl = hashlessUrl + hash;
			window.history.pushState({ path: newurl }, '', newurl);
		}

		// unselects previous active company in the grid desktop only (leaving them selected/expanded on mobile because of DOM reflow issues)
		if (viewportWidth() >= 992) {
			clearSelected();
		}

		// replaces active company div with selected listing details
		updateCompanyDetails();

		// expands selected accordion
		expandSelected();

		if (viewportWidth() <= 991) {
			scrollToCompany();
		}
	}

	// if (viewportWidth() <= 991) {
	// 	scrollToCompany();
	// }
});
